<!-- eslint-disable vue/require-default-prop -->
<script setup lang="ts">
import { ArrowRightIcon } from '@gohighlevel/ghl-icons/24/outline'
import { UIAlert } from '@gohighlevel/ghl-ui'
const props = defineProps({
  showAlert: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  onPrimaryClick: {
    type: Function,
    required: false,
  },
  onSecondaryClick: {
    type: Function,
    required: false,
  },
  showPrimaryButton: {
    type: Boolean,
    required: false,
  },
  showSecondaryButton: {
    type: Boolean,
    required: false,
  },
  primaryButtonText: {
    type: String,
    required: false,
  },
  secondaryButtonText: {
    type: String,
    required: false,
  },
  maxWidth: {
    type: String,
    required: false,
    default: '500px',
  },
  secondaryButtonId: {
    type: String,
    required: false,
  },
  primaryButtonId: {
    type: String,
    required: false,
  },
  handleClose: {
    type: Function,
    required: false,
  },
})

const onClickPrimary = () => {
  if (props.onPrimaryClick) {
    props.onPrimaryClick()
  }
}

const onClickSecondary = () => {
  if (props.onSecondaryClick) {
    props.onSecondaryClick()
  }
}
</script>

<template>
  <div class="absolute z-50 mx-[25%] mt-[10px]" :style="{ maxWidth: maxWidth }">
    <UIAlert v-if="showAlert" type="success" @close="handleClose">
      <template #title>
        <div class="font-medium leading-6 text-success-700">
          {{ title }}
        </div>
      </template>
      <template #actions>
        <div v-if="showSecondaryButton || showPrimaryButton" class="flex gap-2">
          <div
            v-if="showSecondaryButton"
            :id="secondaryButtonId"
            class="cursor-pointer rounded-lg border border-success-100 bg-white px-[12px] py-[6px] font-medium text-success-700"
            role="button"
            @click="onClickSecondary"
            @keydown="onClickSecondary"
          >
            {{ secondaryButtonText }}
          </div>

          <div
            v-if="showPrimaryButton"
            :id="primaryButtonId"
            class="flex cursor-pointer items-center gap-1 rounded-lg border border-success-600 bg-success-600 px-[12px] py-[6px] text-[13px] font-medium text-white"
            role="button"
            @click="onClickPrimary"
            @keydown="onClickPrimary"
          >
            {{ primaryButtonText }}
            <ArrowRightIcon class="w-4 text-white" />
          </div>
        </div>
      </template>
    </UIAlert>
  </div>
</template>
